import React from 'react';
import { upperFirst } from 'lodash';

import CurrentUser from 'auth/CurrentUser';

import ErrorReporter from 'app/components/ErrorReporter';
import FormElement from 'components/FormElement';
import GetCancellationReasonsContainer from 'coaching/containers/GetCancellationReasonsContainer';
import Row from 'components/Row';
import Select from 'components/Select';

type Props = {
  sessionType: 'recurringSchedule' | 'instance';
  changeState: (reason: string) => void;
};

export const CancellationReasons = ({ changeState, sessionType }: Props) => {
  const [selectedReason, setSelectedReason] = React.useState('');
  const currentUser = CurrentUser.getUser();
  const showUpdatedReasons = currentUser.hasFeature(
    'updated_cancellation_reasons.coaching.june-21'
  );

  return (
    <GetCancellationReasonsContainer sessionType={sessionType}>
      {({ cancellationReasons, updatedCancellationReasons, error }) => {
        const options = showUpdatedReasons
          ? updatedCancellationReasons.map(reason => ({
              label: reason.uiLabel,
              value: reason.slug,
            }))
          : cancellationReasons.map(reason => ({
              label: upperFirst(reason.replace(/_/g, ' ')),
              value: reason,
            }));

        if (error || !cancellationReasons) {
          return <ErrorReporter error={error ?? 'Could not load cancellation reasons'} />;
        }
        return (
          <Row>
            <FormElement
              data-test="cancellation-reason-dropdown"
              label="Select a reason"
              element={Select}
              elementProps={{
                options,
                value: selectedReason,
                name: 'reason',
              }}
              onValidChange={value => {
                setSelectedReason(value);
                changeState(value);
              }}
            />
          </Row>
        );
      }}
    </GetCancellationReasonsContainer>
  );
};
